import { gql } from '@apollo/client';

const VARIANT_PACK_COST_INFO_DETAILS_FRAGMENT = gql`
  fragment VariantPackCostInfoDetailsFields on VariantPackDetailedCostInfoResponse {
    cost_in_micros
    type
  }
`;

export const VARIANT_PACK_INFO_FRAGMENT = gql`
  fragment VariantPackInfoContext_InfoFields on GetVariantPackInfoResponse {
    availability_status
    available_quantity
    cost_info {
      details {
        ...VariantPackCostInfoDetailsFields
      }
    }
    currency_code
    default_price_in_micros
    inventory_info {
      quantity_on_hand
      incoming {
        date
        quantity
      }
    }
    list_item_display_text
    manufacturer_suggested_retail_price_in_micros
    price_in_micros
    sales_rep_price_in_micros
    sales_rep_metadata {
      price_ceiling_in_micros
      updated_by_name
    }
    sales_rep_gross_profit_in_percentage
    suggested_retail_price_in_micros
    variant_pack_id
    unit_count
  }

  ${VARIANT_PACK_COST_INFO_DETAILS_FRAGMENT}
`;

export const GET_ESSENTIAL_ITEMS_QUERY = gql`
  query VariantPackInfoContext_GetEssentialItems(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    getCriticalItems(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      variant_pack_id
    }
  }
`;

export const GET_ORDER_GUIDE_VARIANT_PACK_INFO_LIST_QUERY = gql`
  query VariantPackInfoContext_OrderGuideInfoList(
    $deliveryDate: String
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    getVariantPackInfoList(
      delivery_date: $deliveryDate
      supplier_id: $supplierUUID
      restaurant_id: $restaurantUUID
      order_guide_only: true
    ) {
      ...VariantPackInfoContext_InfoFields
    }
  }

  ${VARIANT_PACK_INFO_FRAGMENT}
`;

export const GET_VARIANT_PACK_INFO_LIST_QUERY = gql`
  query VariantPackInfoContext_InfoList(
    $deliveryDate: String
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    getVariantPackInfoList(
      delivery_date: $deliveryDate
      supplier_id: $supplierUUID
      restaurant_id: $restaurantUUID
    ) {
      ...VariantPackInfoContext_InfoFields
    }

    businesses_by_pk(uuid: $supplierUUID) {
      address {
        country_code
        uuid
      }
      uuid
    }
  }

  ${VARIANT_PACK_INFO_FRAGMENT}
`;

export const GET_VARIANT_PACK_LAST_PURCHASE_INFO_QUERY = gql`
  query VariantPackInfoContext_LastPurchaseInfo($chatUUID: uuid!) {
    getVariantPackLastPurchaseInfo(chat_id: $chatUUID) {
      cost_info {
        details {
          ...VariantPackCostInfoDetailsFields
        }
      }
      fulfillment_date
      order_date
      price_in_micros
      quantity
      unit_count
      variant_pack_id
    }
  }

  ${VARIANT_PACK_COST_INFO_DETAILS_FRAGMENT}
`;

export const GET_ORDER_CONSTRAINTS_QUERY = gql`
  query VariantPackInfoContext_OrderConstraints(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    getOrderConstraintsForRestaurant(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      order_constraints {
        max_quantity
        min_quantity
      }
      variant_pack_id
    }
  }
`;
